import React from "react";

import InputText, { PropsType as InputTextPropsType } from "commons/ui/input/InputText";

function AutosizeTextarea(props: InputTextPropsType) {
    const textAreaRef = React.useRef<HTMLTextAreaElement | null>(null);

    React.useEffect(() => {
        if (textAreaRef && textAreaRef.current) {
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.current.style.height = "0px";
            const scrollHeight = textAreaRef.current.scrollHeight;

            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            textAreaRef.current.style.height = scrollHeight + "px";
        }
    }, [textAreaRef, props.value]);

    return <InputText ref={textAreaRef} {...props} textarea />;
}

export default AutosizeTextarea;
